<div class="slide-up-container">
  <div class="title-bar">
    <div class="title" [@fadeIn]>{{title}}</div>
    <div class="close-title-button" (click)="close()" transloco='×'></div>
  </div>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
